<template>
    <v-card outlined>
        <v-row no-gutters>
            <v-col cols="12">
                <draggable v-model="variables" handle=".handle" @input="emit">
                    <variables-item
                        v-for="(item, index) in variables"
                        :key="item.tempId"
                        v-model="variables[index]"
                        v-bind="{
                            showsDivider: index < variables.length - 1,
                        }"
                        v-on="{
                            pull,
                        }"
                        @input="emit"
                    />
                </draggable>
            </v-col>
            <template v-if="!variables.length">
                <v-col cols="12" class="px-4 caption d-flex flex-column justify-center align-center" style="height: 40px">
                    <span> 추가된 항목이 없습니다 </span>
                </v-col>
            </template>
            <v-col cols="12"> <v-divider /> </v-col>
            <v-col cols="12">
                <v-row no-gutters>
                    <v-spacer />
                    <v-divider vertical />
                    <v-btn icon tile width="40" min-height="40" color="primary" @click="push">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-row>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import Draggable from "vuedraggable";
import { initCommonMetatagVariable } from "@/store/metatags";

import VariablesItem from "./variables-item.vue";

export default {
    components: {
        Draggable,
        VariablesItem,
    },
    props: {
        value: { type: Array, default: () => [] },
    },
    data: () => ({
        variables: [],
    }),
    methods: {
        sync() {
            this.variables = [...this.value].map(initCommonMetatagVariable);
        },
        emit() {
            this.$emit("input", this.variables);
        },
        push() {
            this.variables.push(initCommonMetatagVariable());
            this.emit();
        },
        pull(item) {
            let index = this.variables.findIndex(({ tempId }) => tempId == item.tempId);
            if (-1 < index) this.variables.splice(index, 1);
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>
